export default {
  'Custom': 'Cамоопределение',
  'Original': 'Оригинал',
}